module.exports = __webpack_public_path__ + "img/youtube-icon.d8cedc9f.png";